import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom";
import {APP_STATUS, PBDQ3_PROGRAM_STATE, RATING_TYPE} from "../../utils/constants";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import RatingProgramsListView from "../../views/ver_24.10/ProgramRating/RatedProgramsList.view";
import {fetchAllRatingProgramsService} from "../../services/rating.service";

const RatedProgramsList = () => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [ratingPrograms, setRatingPrograms] = useState([]);

    useEffect(() => {
        setShowLoader(true);
        initializeFetchAllRatingPrograms().then(resp => setShowLoader(false)).catch(err => setShowLoader(false));
    }, []);

    const initializeFetchAllRatingPrograms = async () => {
        setShowLoader(true);
        try {
            const result = await fetchAllRatingProgramsService();
            if (result && result.data) {
                console.log('programs_fetched: ', result.data.all_program_applications);
                setRatingPrograms(result.data.all_program_applications);
            }

        } catch (e) {
            // already toasted the error
        }
        setShowLoader(false);
    };

    const data = {
        ratingPrograms,
    };

    const actions = {

        createProgramAction: () => {
            history.push(`/rating/program/welcome`);
        },
        addProgramInfoAction: (programId, rating_type) => {
            const rating = rating_type === RATING_TYPE.CPC_STARS_RATING ? 'dq_stars_rating' : 'dq_rating';
            history.push(`/${rating}/${programId}/company-program-info`);
        },
        viewProgramAction: (programId, program_status, rating_type) => {
            const rating = rating_type === RATING_TYPE.CPC_STARS_RATING ? 'dq_stars_rating' : 'dq_rating';
            if (programId && program_status <= APP_STATUS.PROGRAM_DRAFT ) {
                history.push(`/${rating}/program/new?programId=${programId}`);
            } else if (programId && program_status <= APP_STATUS.PROGRAM_DATA_SUBMITTED ) {
                history.push(`/${rating}/${programId}/company-program-info`);
            } else if (programId && program_status <= APP_STATUS.PROGRAM_SUMMARY_REPORT_HALTED ) {
                history.push(`/${rating}/${programId}`);
            } else if (programId && program_status <= APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED ) {
                history.push(`/${rating}/${programId}/content_report`);
            }
        },
        viewFullReportAction: (programId, program_payment_status, program_status, rating_type) => {
            const rating = rating_type === RATING_TYPE.CPC_STARS_RATING ? 'dq_stars_rating' : 'dq_rating';
            if (programId && program_payment_status === APP_STATUS.COMPLETED && program_status === APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED ) {
                history.push(`/${rating}/${programId}/full_report`);
            } else if (programId && program_payment_status === APP_STATUS.COMPLETED && program_status < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED ) {
                history.push(`/${rating}/${programId}`);
            } else if (programId && program_payment_status < APP_STATUS.COMPLETED && program_status < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED ) {
                history.push(`/${rating}/${programId}`);
            } else {
                history.push(`/${rating}/${programId}/payment`);
            }
        }
    };

    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <div>
                <RatingProgramsListView data={data} actions={actions} options={options}/>
            </div>
        </>
    );
}

export default RatedProgramsList;